import "./App.css";
import * as React from "react";
import {
  Route,
  createBrowserRouter,
  createRoutesFromElements,
  RouterProvider,
  Navigate,
} from "react-router-dom";
import Service from "./component/service/Service";
import RootLayout from "./layout/RootLayout";
import Operation from "./component/operation/Operation";
import CreateSiteAdmin from "./component/operation/create-site-admin/CreateSiteAdmin";
import Logout from "./layout/LogoutLayout";
import NotAuthorizedLayout from "./layout/NotAuthorizedLayout";
import NotFoundLayout from './layout/NotFoundLayout';
import CheckBadgeStatus from "./component/operation/check-badge-status/CheckBadgeStatus";
import PinReset from "./component/operation/pin-reset/PinReset";
import Loading from "./component/common/Loading";
import { setLocale } from "./localization/LocalizationModule";
import GenerateSiteWiseReport from './component/operation/generate-site-report/GenerateSiteWiseReport';
import GenerateMultiSiteReport from './component/operation/generate-site-report/GenerateMultiSiteReport';
import RevokeBadge from './component/operation/revoke-badge/RevokeBadge';
import SearchAssociate from './component/operation/re-register/SearchAssociate';

const AgenticRoot = React.lazy(() => import("./agentic"));
const setDefaultLocale = () => {
    const queryParams = new URLSearchParams(window.location.search);
    setLocale(queryParams.get("ui_locales"));
}
const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/">
        <Route index element={<Navigate to="services" />} />
        {/*  /!*We decided to remove landing page, currently commenting the below line, we could end up using in future releases based on requirements*!/*/}
        {/*<Route index element={<HomeComponent/>}/>*/}
        <Route path="services">
            <Route element={<RootLayout />}>
                <Route index element={<Service />} />
                <Route path="name_maask/operations">
                    <Route index element={<Operation />} />
                    <Route path="createLocationAdmin">
                        <Route index element={<CreateSiteAdmin />} />
                    </Route>
                    <Route path="revokeBadge">
                        <Route index element={<RevokeBadge />} />
                    </Route>
                    <Route path="pinReset">
                        <Route index element={<PinReset />} />
                    </Route>
                    <Route path="badgeStatus">
                        <Route index element={<CheckBadgeStatus />} />
                    </Route>
                  <Route path="generateSiteReport">
                    <Route index element={<GenerateSiteWiseReport />} />
                  </Route>
                  <Route path="generateMultiSiteReport">
                    <Route index element={<GenerateMultiSiteReport />} />
                  </Route>
                  <Route path="reRegister">
                    <Route index element={<SearchAssociate />} />
                  </Route>
                </Route>
            </Route>
            <Route
                path="agentic/*"
                element={
                    <React.Suspense fallback={<Loading />}>
                        <AgenticRoot />
                    </React.Suspense>
                }
            />
        </Route>

        <Route path="logout" element={<Logout />} />
        <Route path="notAuthorized" element={<NotAuthorizedLayout />} />
        <Route path="*" element={<NotFoundLayout />} />
    </Route>
  )
);

function App() {
  setDefaultLocale()
  return <RouterProvider router={router} />;
}

export default App;
